<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('remind_ar_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/remindar" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card n_card no-bor">
                <div class="card-body" style="padding: 0;">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('remind_ar_name') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td><router-link :to="{name:'user_group_update', params: { id: ret.Id }}">{{ret.Name}}</router-link></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>